import { Linkedin, Mail, ArrowUpRight } from "lucide-react";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      id="contact"
      data-testid="footer-section"
      className="relative bg-[#050505] border-t border-[#141414] pt-20 sm:pt-24 md:pt-32 pb-10 sm:pb-12"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-12">
        <div className="flex items-center gap-3 mb-8 sm:mb-10">
          <span className="h-px w-8 bg-[#C5A880]" />
          <span className="text-[11px] font-semibold tracking-[0.3em] uppercase text-[#C5A880]">
            Contact / 09
          </span>
        </div>

        <h2
          data-testid="footer-headline"
          className="huge-display text-[15vw] sm:text-[14vw] md:text-[12vw] lg:text-[10vw] text-[#F5F5F0]"
        >
          Let’s{" "}
          <em className="italic text-[#C5A880]">build</em> what’s next.
        </h2>
        <p className="mt-5 sm:mt-6 max-w-xl text-[15px] sm:text-base md:text-lg text-[#A3A39A] leading-relaxed">
          One message. One direct response. Usually within two business days.
        </p>

        <div className="mt-12 sm:mt-16 grid grid-cols-1 md:grid-cols-12 gap-8 border-t border-[#1a1a1a] pt-10 sm:pt-12">
          <div className="md:col-span-5">
            <div className="text-[11px] tracking-[0.3em] uppercase text-[#A3A39A] mb-3 sm:mb-4">
              Direct
            </div>
            <a
              href="mailto:hello@denisantony.com"
              data-testid="footer-email"
              className="group inline-flex items-center gap-3 font-serif-display text-2xl sm:text-3xl md:text-4xl font-light text-[#F5F5F0] hover:text-[#C5A880] transition-colors break-all"
            >
              <Mail className="w-5 h-5 text-[#C5A880] flex-shrink-0" />
              <span className="break-all">hello@denisantony.com</span>
              <ArrowUpRight className="hidden sm:block w-5 h-5 opacity-0 group-hover:opacity-100 -translate-x-1 group-hover:translate-x-0 transition-all flex-shrink-0" />
            </a>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] tracking-[0.3em] uppercase text-[#A3A39A] mb-3 sm:mb-4">
              Social
            </div>
            <a
              href="https://www.linkedin.com/in/denisantonyvk/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-linkedin"
              className="group inline-flex items-center gap-3 font-serif-display text-xl sm:text-2xl md:text-3xl font-light text-[#F5F5F0] hover:text-[#C5A880] transition-colors"
            >
              <Linkedin className="w-5 h-5 text-[#C5A880] flex-shrink-0" />
              LinkedIn
              <ArrowUpRight className="hidden sm:block w-5 h-5 opacity-0 group-hover:opacity-100 -translate-x-1 group-hover:translate-x-0 transition-all flex-shrink-0" />
            </a>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] tracking-[0.3em] uppercase text-[#A3A39A] mb-3 sm:mb-4">
              Operating
            </div>
            <p className="text-[#F5F5F0] text-[15px] sm:text-base leading-relaxed">
              UK · Europe · US ·<br />
              Middle East · APAC
            </p>
          </div>
        </div>

        <div className="mt-16 sm:mt-20 pt-6 sm:pt-8 border-t border-[#1a1a1a] flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[10px] sm:text-[11px] tracking-[0.2em] sm:tracking-[0.25em] uppercase text-[#666]">
          <div>© {year} Denis Antony · All rights reserved</div>
          <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6">
            <a
              href="#home"
              data-testid="footer-back-to-top"
              className="hover:text-[#C5A880] transition-colors"
            >
              Back to top ↑
            </a>
            <span className="leading-relaxed">AI-Driven Product Strategist | Former CPO | Strategic Advisor to CEOs &amp; Founders</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
